'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function accentsTidy(s) {
    var r = (s || '').toLowerCase();
    r = r.replace(new RegExp("[(][^)]+[)]|,|%", 'g'), "");
    r = r.trim();
    r = r.replace(new RegExp("\\s", 'g'), "-");
    r = r.replace(new RegExp("[àáâãäå]", 'g'), "a");
    r = r.replace(new RegExp("č", 'g'), "c");
    r = r.replace(new RegExp("ď", 'g'), "d");
    r = r.replace(new RegExp("[èéêëě]", 'g'), "e");
    r = r.replace(new RegExp("[ìíîï]", 'g'), "i");
    r = r.replace(new RegExp("[ñň]", 'g'), "n");
    r = r.replace(new RegExp("[òóôõö]", 'g'), "o");
    r = r.replace(new RegExp("ř", 'g'), "r");
    r = r.replace(new RegExp("š", 'g'), "s");
    r = r.replace(new RegExp("[ùúûüů]", 'g'), "u");
    r = r.replace(new RegExp("ž", 'g'), "z");
    r = r.replace(new RegExp("[ýÿ]", 'g'), "y");
    r = r.replace(new RegExp("\\+", 'g'), "");
    r = r.replace(new RegExp("---|--", 'g'), "-");
    return r;
}

var FacetItem = function (_React$Component) {
    (0, _inherits3.default)(FacetItem, _React$Component);

    function FacetItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FacetItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FacetItem.__proto__ || (0, _getPrototypeOf2.default)(FacetItem)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
            _this.props.onChange((0, _extends3.default)({}, _this.props.item, { checked: e.target.checked }), e.target);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FacetItem, [{
        key: 'render',
        value: function render() {
            var _props$item = this.props.item,
                groupName = _props$item.groupName,
                name = _props$item.name,
                displayName = _props$item.displayName,
                value = _props$item.value,
                checked = _props$item.checked,
                disabled = _props$item.disabled;


            return _react2.default.createElement(
                'div',
                { className: (disabled ? 'facet-item-disabled disabled ' : '') + ' block-element' },
                _react2.default.createElement('input', { key: name, id: name, name: groupName,
                    'data-filter': 'array',
                    'data-query-target': '#mainContent',
                    value: value, checked: checked || false, type: 'checkbox',
                    onChange: disabled ? null : this.onChange }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: name, className: accentsTidy(displayName) },
                    displayName
                )
            );
        }
    }]);
    return FacetItem;
}(_react2.default.Component);

exports.default = FacetItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/components/facet-item.js
// module id = 398
// module chunks = 0 1